import { Injectable, Injector } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest
} from "@angular/common/http";
import { AuthService } from "./auth.service";
import { Observable } from "rxjs/Observable";
import { Events } from "ionic-angular";
import { HttpHeaders } from "@angular/common/http";
export const interceptorSkipHeader = "X-Skip-Interceptor";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  inflightAuthRequest = null;
  constructor(private inj: Injector, public events: Events) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const auth = this.inj.get(AuthService),
      headers = req.headers
        .set("Accept", "application/json")
        .set("Content-Type", "application/json")
        .set("Access-Control-Allow-Origin", "*")
        .set("Authorization", "Bearer " + auth.jwt);
    let authReq: HttpRequest<any>;
    if (req.headers.has(interceptorSkipHeader)) {
      if ( req.headers.get(interceptorSkipHeader) === "KEEP") {
        return next.handle(req);
      }
      authReq = req.clone({ headers: new HttpHeaders() });
      return next.handle(authReq); // We don't want the JWT expiration logic to fire if we have interceptorSkipHeader
    }
    let isExpired: boolean = null;
    authReq = req.clone({ headers });
    if (auth.jwt !== null) {
      isExpired = auth.jwtHelper.isTokenExpired(auth.jwt);
    }
    if (isExpired === true) {
      auth.resetAppState(true);
    }
    return next.handle(authReq);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.interceptor.ts